import { useTranslation } from 'react-i18next';
import { FieldAttributesConfig } from '../../types/dynamicForm';

/** The `t` returned by useTranslation, as the config builders receive it. */
type Translate = ReturnType<typeof useTranslation>['t'];

/**
 * Help text for the numeration schema template field, shared by the add and
 * edit forms so both list the same placeholders.
 */
export const buildNumerationSchemaFieldAttributes = (t: Translate): FieldAttributesConfig => ({
  template: {
    helperText: (
      <>
        {t('Template uses placeholders for the number. COUNTER is required. Example: CT/{COUNTER}/{YEAR}/{MONTH}/{DAY}')}
        <br />
        <strong>{t('Available tags')}:</strong>
        <br />
        {'{'}COUNTER{'}'} — {t('sequential number (required)')}
        <br />
        {'{'}YEAR{'}'} — {t('year')}
        <br />
        {'{'}MONTH{'}'} — {t('month')}
        <br />
        {'{'}DAY{'}'} — {t('day')}
      </>
    ),
  },
});
